export default "__VITE_ASSET__yc38dKw6__"